export default __webpack_public_path__ + "static/media/call-me-logo.843aab66.svg";